import React, { Component } from "react";
import { Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ResNavBar from "./components/ResNavBar/ResNavBar";
import Home from "./pages/Home/Home";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./pages/Login/Login";
import Orders from "./pages/Orders/Orders";
import Quality from "./pages/Quality/quality";
import Bonds from "./pages/Bonds/Bonds";
import Teams from "./pages/Teams/Teams";
import SearchView from "./pages/Search/Search";
import Register from "./pages/Register/Register";
import NewFinancing from "./pages/NewFinancing/NewFinancing";
import OrderDone from "./pages/OrderDone/OrderDone";
import Client from "./pages/Client/Client";
import AddEmployee from "./pages/AddEmployee/AddEmployee";
import AddTeam from "./pages/AddTeam/AddTeam";
import TeamInfo from "./pages/TeamInfo/TeamInfo";
import ForgetPassword from "./pages/ForgetPassword/ForgetPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import PhoneVerify from "./pages/PhoneVerify/PhoneVerify";  
import SearchBonds from "./pages/SearchBonds/SearchBonds";   
import Profile from "./pages/Profile/Profile";
import Settings from "./pages/Settings/Settings";
import InitialCalculation from "./pages/InitialCalculation/InitialCalculation";
import NewOrder from "./pages/NewOrder/NewOrder";
import Account from "./pages/Account/Account";

class Routes extends Component {
    render() {  
        return (
            <>
                    <Route exact path="/calculate-finance" component={InitialCalculation}  />
                    <Route exact path="/new-order" component={NewOrder} />
                    <Route exact path="/signup" component={Register} />
                    <Route exact path="/signin" component={Login} />
                    <Route exact path="/forget-password" component={ForgetPassword} />
                    <Route exact path="/phone-verification" component={PhoneVerify} /> 
                    <Route exact path="/reset-password" component={ResetPassword} /> 
                    <Route exact path="/signin-account" component={Account} />

            <div className="page-wrapper">
            <Header /> 
            <div className="page-main">
                <ProtectedRoute exact path="/" component={Home} />
                <ProtectedRoute exact path="/orders" component={Orders} />
                <ProtectedRoute exact path="/orders/:tab" component={Orders} />
                <ProtectedRoute exact path="/client/:tab/:id" component={Client} />
                <ProtectedRoute exact path="/quality" component={Quality} />
                <ProtectedRoute exact path="/bonds" component={Bonds} />
                <ProtectedRoute exact path="/teams" component={Teams} />
                <ProtectedRoute exact path="/add-employee" component={AddEmployee} />
                <ProtectedRoute exact path="/add-team" component={AddTeam} />
                <ProtectedRoute exact path="/team-info" component={TeamInfo} />
                <ProtectedRoute exact path="/search" component={SearchView} />
                <ProtectedRoute exact path="/finance" component={NewFinancing} />
                <ProtectedRoute exact path="/client" component={Client} />
                <ProtectedRoute exact path="/new-bond" component={SearchBonds} />
                <ProtectedRoute exact path="/done" component={OrderDone} />
                <ProtectedRoute exact path="/Profile" component={Profile} />
                <ProtectedRoute exact path="/settings" component={Settings} />
            </div>
            
            <Footer /> 
            <ResNavBar /> 
            
            </div>
            </> 
        )}
}

export default Routes;